<template>
  <!-- Modal -->
  <div class="modal fade" ref="vuemodal4" id="BulkSendInvoice" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <vue-element-loading :active="isLoading" spinner="bar-fade-scale" color="#333"/>
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold">{{translations('invoice.batch_delivery_of_invoices')}}</h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <div class="d-flex justify-content-end mb-3">
            <span class="font-weight-bold">{{translations('invoice.total_amount')}}</span>
            <span class="ml-3">{{ grandTotal.toLocaleString() }}</span>
          </div>
          <div class="table-scroll">
            <table class="table table-striped table-align-middle">
              <thead>
                <tr>
                  <th>
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" v-model="selectAll" value="1" id="defaultCheck01">
                      <label class="form-check-label" for="defaultCheck01">{{translations('invoice.choice')}}</label>
                    </div>
                  </th>
                  <th>{{translations('invoice.billing_date')}}</th>
                  <th>{{translations('invoice.customer_name')}}</th>
                  <th colspan="2">{{translations('invoice.email_address')}}</th>
                  <th>{{translations('invoice.amount')}}</th>
                </tr>
              </thead>
              <tbody class="nowrap">
                <template v-for="(item, i) in nonebuildSales">
                  <tr :key="i">
                    <td>
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" v-model="selectedNBSales" :value="item" :id="'defaultCheck'+i">
                        <label class="form-check-label" :for="'defaultCheck'+i"></label>
                      </div>
                    </td>
                    <td>{{ $invoiceTools.formatDate(item.billed_at) }}</td>
                    <td>
                      <a class="decoration-underline" href="#" @click="getRealtimePdf(item.client_id, item.id)">{{ item.client_name }}</a>
                    </td>
                    <td colspan="2">
                      <v-select v-if="item.clients_in_charge.length > 1" v-model="item.sendClient" @input="setSendTo($event,item)" :options="item.clients_in_charge" label="disp_name" value="email" :clearable="false"></v-select>
                      <span v-else-if="item.clients_in_charge.length === 1">{{ item.clients_in_charge[0].disp_name }}</span>
                    </td>
                    <td class="right">{{ item.billed.toLocaleString() }}</td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button ref="closeModal" type="button" class="btn btn-secondary" data-dismiss="modal">{{translations('common.close')}}</button>
          <button type="button" class="btn btn-primary" @click="sendBills()">{{translations('common.send')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import { mapState } from 'vuex'
export default {
  name: 'BulkSendInvoice',
  components: {
    VueElementLoading
  },
  props: {
    dateFrom: String,
    dateTo: String
  },
  data () {
    return {
      nonebuildSales: [],
      selectedNBSales: [],
      selectAll: 0,
      staffOptions: [],
      grandTotal: 0,
      isLoading: false,
      realtimePdf: null
    }
  },
  watch: {
    selectAll (v) {
      this.selectAll = v
      this._selectAll()
    }
  },
  created () {
  },
  mounted () {
    window.$(this.$refs.vuemodal4).on('shown.bs.modal', this.loadNBSales)
    window.$(this.$refs.vuemodal4).on('hidden.bs.modal', this.resetData)
  },
  computed: {
    ...mapState(['currentLanguage'])
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    resetData () {
      this.nonebuildSales = []
      this.selectedNBSales = []
      this.selectAll = 0
      this.grandTotal = 0
    },
    defaultSetInCharge (nonebuildSales) {
      nonebuildSales.forEach(item => {
        if (item.clients_in_charge !== null) {
          if (item.clients_in_charge.length > 1) {
            // item.staffOptions = item.clients_in_charge.map(item2 => {
            //   return item2.contactstaffname + '（' + item2.email + '）'
            // })
            item.sendClient = item.clients_in_charge[0]
          }
        }
      })
    },
    setSendTo (value, item) {
      console.log(value.email)
      item.sendTo = value.email
      console.log(item)
    },
    async loadNBSales () {
      this.isLoading = true
      try {
        let params = {
          start_at: this.dateFrom,
          end_at: this.dateTo
        }
        let nonbilledList = await this.$http.post(this.$api_url.billing_nonbilled_list, params)
        let $data = this.$invoiceTools.prepareResult(nonbilledList.data, ['list', 'total'], 'BulkSendInvoiceModal:loadClosedList')
        if ($data.success === true) {
          this.grandTotal = $data.data.total
          this.nonebuildSales = $data.data.list
          this.defaultSetInCharge(this.nonebuildSales)
        } else {
          this.$toastr.error($data.data, 'エラー')
        }
        this.isLoading = false
      } catch (error) {
        console.log('BulkSendInvoiceModal:loadClosedList:catch(error): ', error)
        this.$toastr.error(
          'エラーのため失敗しました。ご確認後、再試行してください。',
          'エラー'
        )
        this.isLoading = false
      }
    },
    _selectAll () {
      if (this.selectAll) {
        this.selectedNBSales = this.nonebuildSales
      } else {
        this.selectedNBSales = []
      }
    },
    async getRealtimePdf (cId, bId) {
      this.isLoading = true
      try {
        let readtimePdf = await this.$http.post(
          this.$api_url.show_realtime_billing,
          {
            clients_ids: cId,
            billing_id: bId
          }
        )
        // console.log('BulkSendInvoiceModal:getRealtimePdf', readtimePdf)
        if (readtimePdf.data.status === true && readtimePdf.data.bill !== '') {
          this.realtimePdf = readtimePdf.data.bill
        } else {
          this.realtimePdf = null

          // テストデータ
          // this.realtimePdf = this.loadPoFile()
        }
        this.isLoading = false
        this.openRealtimePdf()
      } catch (error) {
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
        this.isLoading = false

        // テストデータ
        // this.realtimePdf = this.loadPoFile()

        this.openRealtimePdf()
      }
    },
    openRealtimePdf () {
      if (this.realtimePdf != null) {
        let arrBuff = this.__b64ToArrayBuffer(this.realtimePdf.replace('data:application/pdf;base64,', ''))
        const realtimePdf = new Blob([arrBuff], { type: 'application/pdf' })
        const realtimePdfURL = URL.createObjectURL(realtimePdf)
        window.open(realtimePdfURL)
      }
    },

    __b64ToArrayBuffer (base64) {
      let binaryString = window.atob(base64)
      let len = binaryString.length
      let bytes = new Uint8Array(len)
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }
      return bytes.buffer
    },
    async sendBills () {
      try {
        let params = []
        this.selectedNBSales.forEach(item => {
          if (item.clients_in_charge.length === 1) {
            item.sendTo = item.clients_in_charge[0].email
          }
          params.push({ billing_id: item.id, send_to: item.sendTo })
        })

        if (params.length === 0) {
          this.$toastr.error('宛先を選択してください。', 'エラー')
          return
        }

        let sendBills = await this.$http.post(this.$api_url.billing_send_bills, { client_ids: params })
        let $data = this.$invoiceTools.prepareResult(sendBills.data, '', 'BulkSendInvoiceModal:sendBills')
        if ($data.success === true) {
          this.$toastr.success('メールを送信しました。', 'Success')
          this.$refs.closeModal.click()
          setTimeout(() => {
            this.$emit('sended')
          }, 100)
        } else {
          this.$toastr.error($data.data, 'エラー')
        }
      } catch (error) {
        console.log('BulkSendInvoiceModal:sendBills:catch(error): ', error)
        this.$toastr.error(
          'エラーのため失敗しました。ご確認後、再試行してください。',
          'エラー'
        )
      }
    }
  }
}
</script>
